<template>
  <PulseModal :open="open" style="max-width: 544px" class="ota-modal" @close="$emit('close')">
    <template #header> {{ computedTitle }}</template>

    <section class="text-base text-typography-disabled mb-4">
      <p>{{ computedEligibility }}</p>
    </section>

    <section>
      <p class="text-xs text-typography-disabled">{{ t('*For approved claims only.') }}</p>
    </section>

    <template #footer>
      <PulseButton @click="$emit('close')">{{ t('Continue to file claim') }}</PulseButton>
    </template>
  </PulseModal>
</template>

<script setup>
const emit = defineEmits(['close']);

const props = defineProps({
  eligibility: {
    default: '',
    type: String,
  },
  open: {
    default: false,
    type: Boolean,
  },
  title: {
    default: '',
    type: String,
  },
});

const computedTitle = computed(() => {
  return props.title || t("Good news—You're eligible for a one-time order issue resolution!*");
});

const computedEligibility = computed(() => {
  return (
    props.eligibility ||
    t("In order to be eligible to file claims in the future, you'll need to purchase Shipping Protection at checkout.")
  );
});

const { t } = useI18n();
</script>
